import Vue from 'vue';
import { CallbackEvent } from '@/core/Utility/CallbackEvent.js';

export function DrawDeliveryModalController () {
    this.campaign = {};
    this.tag = '';
    this.busModal = new Vue();

    //#region callback
    this.cbClose = new CallbackEvent();
    this.cbAction = new CallbackEvent();
    //#endregion callback

    //#region setter
    this.setCampaign = function (campaign) {
        this.campaign = campaign;
        return this;
    };
    this.setTag = function (tag) {
        this.tag = tag;
        return this;
    };
    this.clearModal = function () {
        this.campaign = {};
        this.tag = '';
        this.cbClose = new CallbackEvent();
        this.cbAction = new CallbackEvent();
    };
    //#endregion setter

    //#region modal control
    this.show = function () {
        var config = {
            campaign: this.campaign,
            tag: this.tag
        };

        this.busModal.$emit('show', config);
    };
    this.hide = function () {
        this.busModal.$emit('hide');
    };
    //#endregion modal control
}
